export default __webpack_public_path__ + "static/media/1.1 Diba Superapps.fec38362.png";